import { getTypographyStyles, SYS_SIZE_FIXED_500, SEM_BORDER_WIDTH_FORMS_DEFAULT, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150, SEM_TYPOGRAPHY_FORMS_APPENDIX, SEM_TYPOGRAPHY_FORMS_LABEL, getMargins } from '@oneaudi/unified-web-common';
import {} from './index.js';
import styled, { css } from 'styled-components';
import { Icon } from '../../components/icon/index.js';
import { FormMessage } from '../form-message/index.js';
const marginLeft = parseFloat(SYS_SIZE_FIXED_500) + parseFloat(SYS_SPACE_FIXED_150);
export const StyledFormMessage = styled(FormMessage) `
  margin-left: ${marginLeft}px;
`;
export const StyledCheckboxContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${SYS_SPACE_FIXED_100};
  margin: ${(props) => getMargins(props.margin)};
`;
export const StyledBox = styled.span `
  width: ${SYS_SIZE_FIXED_500};
  height: ${SYS_SIZE_FIXED_500};
  border: ${SEM_BORDER_WIDTH_FORMS_DEFAULT} solid
    ${(props) => props.theme.sem.color.forms.surface.control.stroke.default};
  box-sizing: border-box;

  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition-property: border-color;
  // TODO: token missing;
  transition-duration: 250ms;
  // TODO: token missing;
  transition-timing-function: ease;
`;
export const StyledIcon = styled(Icon) `
  transform: scale(0);
  visibility: hidden;
  transition-property: transform, visibility;
  // TODO: token missing;
  transition-duration: 0.1s;
  // TODO: token missing;
  transition-timing-function: ease;

  ${(props) => props.invalid &&
    css `
      color: ${props.theme.sem.color.forms.foreground.icons.error};
    `}
`;
export const StyledTextContent = styled.div `
  display: flex;
  align-items: baseline;
  gap: ${SYS_SPACE_FIXED_150};

  transition-property: color;
  // TODO: token missing;
  transition-duration: 250ms;
  // TODO: token missing;
  transition-timing-function: ease;
`;
export const StyledInput = styled.input `
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  white-space: nowrap;
  width: 1px;
  position: absolute;
  opacity: 0;
  pointer-events: none;

  ${(props) => !props.invalid &&
    css `
      &:hover:not(:disabled)
        + ${StyledBox},
        &:checked:not(:disabled)
        + ${StyledBox} {
        border-color: ${(props) => props.theme.sem.color.forms.surface.control.stroke.interactive};
      }
    `}

  &:disabled + ${StyledBox} {
    color: ${(props) => props.theme.sem.color.forms.foreground.icons.disabled};
    border-color: ${(props) => props.theme.sem.color.forms.surface.control.stroke.disabled};
    cursor: not-allowed;
  }

  &:checked + ${StyledBox} {
    ${StyledIcon} {
      visibility: visible;
      transform: scale(1);
    }
  }

  &:focus {
    & + ${StyledBox} {
      outline: 2px solid Highlight;
      outline: 2px solid -webkit-focus-ring-color;
      outline-style: auto;
    }
  }

  &:focus:not(:focus-visible) + ${StyledBox} {
    outline: none;
  }
`;
export const StyledLabel = styled.label `
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL)};
  color: ${(props) => props.theme.sem.color.forms.foreground.text.default};
  display: flex;
  column-gap: ${SYS_SPACE_FIXED_150};
  align-items: top;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};

  ${(props) => !props.invalid &&
    css `
      &:has(${StyledInput}:disabled) {
        ${StyledTextContent} {
          color: ${(props) => props.theme.sem.color.forms.foreground.text.disabled};
        }
      }

      &:has(${StyledInput}:hover:not(:disabled)) {
        ${StyledTextContent} {
          color: ${(props) => props.theme.sem.color.forms.foreground.text.interactive};
        }
      }

      &:has(${StyledInput}:checked:not(:disabled)) {
        ${StyledTextContent} {
          color: ${(props) => props.theme.sem.color.forms.foreground.text.interactive};
        }
      }
    `}

  ${(props) => props.invalid &&
    css `
      ${StyledBox} {
        border-color: ${props.theme.sem.color.forms.surface.control.stroke
        .error};
      }

      ${StyledTextContent} {
        color: ${props.theme.sem.color.forms.foreground.text.error};
      }
    `}
`;
export const StyledAppendix = styled.div `
  color: ${(props) => props.theme.sem.color.forms.foreground.text.caption};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_APPENDIX)};
`;
//# sourceMappingURL=index.styles.js.map